import { IPaymentCard } from "@wingspanhq/payments/dist/interfaces";

export const selectorPaymentCardPayoutReady = (paymentCard: IPaymentCard) => {
  if (isWingspanIssuedCard(paymentCard)) {
    return false;
  }

  if (isDiscoverCard(paymentCard)) {
    return false;
  }

  return true;
};

function isWingspanIssuedCard(paymentCard: IPaymentCard) {
  return paymentCard.issuer.toLowerCase() === "wingspan";
}

function isDiscoverCard(paymentCard: IPaymentCard) {
  return paymentCard.brand.toLowerCase() === "discover";
}
